import classNames from 'classnames';
import { FC, useEffect, useRef, useState } from 'react';
import { IErrorModalProps } from './types/errorModal';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import { localeStore } from 'src/mobx/localesStore';
import { formatDate } from 'src/utils/helpers';
import Icon from 'src/view/components/Controls/Icon/Icon';
import Portal from 'src/view/components/Portal/Portal';
import Text, { TEXT } from 'src/view/components/Text/Text';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import { modalStore } from '~/mobx/modalStore';
import './style.scss';

const emptyModalHeight: number = 327;

const ErrorModal: FC<IErrorModalProps> = ({ id, title, message, onClose, className, contentClassName }: IErrorModalProps) => {
  const modalRef = useRef<HTMLDivElement | null>(null);
  const [contentHeight, setContentHeight] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (modalRef.current && !contentHeight) {
      setContentHeight(emptyModalHeight + modalRef.current.getClientRects()[0].height);
    }
  }, [modalRef, message]);

  const requestClose = () => {
    if (typeof onClose === 'function') onClose();
    modalStore.closeErrorModal(id);
  };

  const messages: string[] | undefined = message?.split(';');

  return (
    <Portal>
      <div className={classNames('error-modal', className)}>
        <div className="error-modal__backdrop" onClick={requestClose} />

        <div className={classNames('error-modal__content', contentClassName)} style={{ height: contentHeight }}>
          <Icon name={Icons.Warning} size={85} color={theme.colors.red} className="mt-4" />

          {/* title */}
          <Text type={TEXT.MODAL_MESSAGE} text={title || 'smth_went_wrong'} className="mt-8" />

          {/* message */}
          {messages && messages.length ? (
            <ScrollableBlock showScrollbar scrollbarSize="normal" className="full-width mt-5" scrollClassName="d-flex flex-column align-items-center">
              <div ref={modalRef} className="d-flex flex-column align-items-center full-width">
                {messages.map((message, index) => (
                  <span key={message + String(index)} className="error-modal__message">
                    {message}
                  </span>
                ))}
              </div>
            </ScrollableBlock>
          ) : null}

          {/* time */}
          <p className="error-modal__time">
            {localeStore.t('error_occured_at') + ' ' + formatDate(new Date(), { militaryFormat: true, includeSecond: true })}
          </p>

          <Icon name={Icons.Close} size={14} color={theme.colors.gray2} onPress={requestClose} className="error-modal__close" />
        </div>
      </div>
    </Portal>
  );
};

export default ErrorModal;
